import { FC, memo } from "react";

import Grid from "apps/website/components/layout/Grid/Grid";
import { AvailableTag } from "apps/website/components/base/List/List.map";

import HorizontalIconTextListItem, {
  IHorizontalIconTextListItem,
} from "./HorizontalIconTextListItem/HorizontalIconTextListItem";

export interface IHorizontalIconTextList {
  items: IHorizontalIconTextListItem[];
  listTag?: AvailableTag;
}

const IconTextList: FC<IHorizontalIconTextList> = ({ items = [], listTag = "ul" }) => (
  <Grid tag={listTag} component="HorizontalIconTextList">
    { items.map((item, index) => (
      <HorizontalIconTextListItem
        key={item.title}
        { ...item }
        count={ listTag === "ol" ? index + 1 : undefined }
      />
    )) }
  </Grid>
);

export default memo(IconTextList);
